import { render, staticRenderFns } from "./pointCouponModal.vue?vue&type=template&id=0b32f468&scoped=true"
import script from "./pointCouponModal.vue?vue&type=script&lang=js"
export * from "./pointCouponModal.vue?vue&type=script&lang=js"
import style0 from "./pointCouponModal.vue?vue&type=style&index=0&id=0b32f468&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b32f468",
  null
  
)

export default component.exports